<template>
 <div>
    <div class="vtext-body vmb-20">
      <b>1. </b>
      <span>Get the app from the </span>
      <span>
        <a href="https://apps.apple.com/us/app/google-authenticator/id388497605" target="_blank" rel="noopener noreferrer">App Store</a>
        <span> or </span>
        <a href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2" target="_blank" rel="noopener noreferrer">Play Store</a>
      </span>
    </div>
    <div class="vtext-body vmb-20">                    
      2. In the app, select 'Add Account' or '+' icon
    </div>
    <div class="vtext-body vmb-20">                    
      3. Scan the QR code below.
    </div>
    <div class="qr-wrapper">
      <img :src="qrCode" alt="MFA-QR" width="120" class="full-brdr" />
    </div>
    <div class="vtext-body vpb-10">                    
      4. Enter the code.
    </div>
 </div>
</template>

<script>
export default {
  props: {
    qrCode: {
      type: String
    },
  },
  data() {
    return {
    };
  },
};
</script>

<style lang="scss" scoped src="../resources/css/settings.scss"> </style>
